// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"703":"ccad35bb","880":"e774c604"}[chunkId] + ".chunk.js";
};